export default "__VITE_ASSET__89a1d9b1__"